import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import type { Declaration, ImageGroup } from './useDeclarations';

export type UpsertDeclarationPayload = Omit<Declaration, 'id'> & {
  id?: string; // optional for insert
  image_url?: string | null;
  additional_images?: string[] | null;
  image_groups?: ImageGroup[] | null;
};

export const useUpsertDeclaration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UpsertDeclarationPayload) => {
      const { id, ...rest } = payload;
      if (id) {
        const { data, error } = await supabase
          .from('confessions')
          .update(rest)
          .eq('id', id)
          .select()
          .single();
        if (error) throw error;
        return data;
      }
      const { data, error } = await supabase.from('confessions').insert(rest).select().single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
    },
  });
};
